export default from './notification-button';



// WEBPACK FOOTER //
// ./app/components/notification-button/index.js